import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const MegaphoneIcon = ({ color = '#0D84FE', size = 14, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 21 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.317 9.203c0-.877-.456-1.635-1.128-2.046V1.484c0-.325-.246-1.188-1.129-1.188-.251 0-.5.089-.705.26l-3 2.525A8.3 8.3 0 0 1 9.03 5.046H2.257C1.011 5.046 0 6.11 0 7.421v3.563c0 1.312 1.01 2.375 2.257 2.375h1.19a9.48 9.48 0 0 0-.078 1.187c0 1.476.327 2.87.902 4.117.183.397.583.633 1.002.633h2.62c.919 0 1.47-1.107.913-1.876a4.887 4.887 0 0 1-.922-2.874c0-.412.057-.808.156-1.187h.99c1.928 0 3.82.698 5.326 1.965l2.999 2.524c.2.169.448.26.705.26.879 0 1.128-.845 1.128-1.187v-5.673a2.389 2.389 0 0 0 1.13-2.045zm-3.386 5.248-1.166-.982c-1.904-1.603-4.297-2.485-6.735-2.485V7.42c2.438 0 4.83-.882 6.735-2.485l1.166-.981V14.45z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

MegaphoneIcon.propTypes = propTypes;

export default MegaphoneIcon;
